const { cloneDeep, omit } = require('lodash');

const indentMasterType = {
  EXIM: 1,
};

const indentMasterTypeMeta = {
  [indentMasterType.EXIM]: {
    masterField: 'exim_detail',
    attachmentsConf: 'exim_attachments',
  },
};

const legType = {
  ROAD: 1,
  OCEAN: 2,
  AIR: 3,
  RAIL: 4,
};

const vehicleTypeMode = omit(cloneDeep(legType), ['OCEAN']);
const vehicleTypeModeBasedOnDelivery = [
  { id: 1, delivery_type: 'FTL', vehicleTypeMode: vehicleTypeMode.ROAD },
  { id: 2, delivery_type: 'FTL', vehicleTypeMode: vehicleTypeMode.OCEAN },
  { id: 3, delivery_type: 'FTL', vehicleTypeMode: vehicleTypeMode.AIR },
  { id: 4, delivery_type: 'FTL', vehicleTypeMode: vehicleTypeMode.RAIL },
  { id: 5, delivery_type: 'PTL', vehicleTypeMode: vehicleTypeMode.ROAD },
  { id: 6, delivery_type: 'PTL', vehicleTypeMode: vehicleTypeMode.OCEAN },
  { id: 7, delivery_type: 'PTL', vehicleTypeMode: vehicleTypeMode.AIR },
  { id: 8, delivery_type: 'PTL', vehicleTypeMode: vehicleTypeMode.RAIL },
];

const legTypeMapping = {
  1: 'ROAD',
  2: 'OCEAN',
  3: 'AIR',
  4: 'RAIL',
};

const masterEximStatus = [
  {
    id: 1,
    name: 'indented',
    label: 'Indented',
    color: 'status-purple',
  },
  {
    id: 2,
    name: 'indent_accepted',
    label: 'FF Accepted',
    color: 'status-pink',
  },
  {
    id: 3,
    name: 'indent_rejected',
    label: 'FF Rejected',
    color: 'status-red',
  },
  {
    id: 4,
    name: 'container_booked',
    label: 'CTR Booked',
    color: 'status-blue',
  },
  {
    id: 5,
    name: 'cancelled',
    label: 'Cancelled',
    color: 'status-red',
  },
  {
    id: 6,
    name: 'on_road',
    label: 'On Road',
    color: 'status-teal',
  },
  {
    id: 7,
    name: 'road_delivered',
    label: 'Road: Delivered',
    color: 'status-green',
  },
  {
    id: 8,
    name: 'on_ocean',
    label: 'On Ocean',
    color: 'status-teal',
  },
  {
    id: 9,
    name: 'delivered',
    label: 'Delivered',
    color: 'status-green',
  },
  {
    id: 10,
    name: 'ocean_delivered',
    label: 'Ocean: Delivered',
    color: 'status-green',
  },
  {
    id: 11,
    name: 'delivered_at_border',
    label: 'Delivered At Border',
    color: 'status-green',
  },
  {
    id: 12,
    name: 'indented',
    label: 'Indented',
    color: 'status-purple',
  },
  {
    id: 13,
    name: 'on_air',
    label: 'On Air',
    color: 'status-teal',
  },
  {
    id: 14,
    name: 'air_delivered',
    label: 'Air: Delivered',
    color: 'status-green',
  },
  {
    id: 15,
    name: 'container_booked',
    label: 'Shipment Booked',
    color: 'status-blue',
  },
];

module.exports = {
  indentMasterType,
  indentMasterTypeMeta,
  legType,
  masterEximStatus,
  legTypeMapping,
  vehicleTypeMode,
  vehicleTypeModeBasedOnDelivery,
};
